module.exports = __webpack_public_path__ + "static/media/Viserys Targaryen 3.16e3eba4.jpg";